/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/training_cost': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 1a9 9 0 100 18 9 9 0 000-18zm0 2a7 7 0 110 14 7 7 0 010-14z"/><path pid="1" d="M9 5h2v5.200l2-2 1.400 1.400L10 14 5.600 9.600 7 8.200l2 2z"/>'
  }
})
